import { render, staticRenderFns } from "./TorreAireaPlus.vue?vue&type=template&id=bf9b5a10"
import script from "./TorreAireaPlus.vue?vue&type=script&lang=js"
export * from "./TorreAireaPlus.vue?vue&type=script&lang=js"
import style0 from "./TorreAireaPlus.vue?vue&type=style&index=0&id=bf9b5a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports